import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { Badge } from '@/components/ui/badge';
import { ChevronDown, ChevronRight, MessageCircle } from 'lucide-react';
import { useState } from 'react';

export function WorkflowCommunicationsSection() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger asChild>
        <div className="flex items-center justify-between p-4 cursor-pointer hover:bg-muted/50 rounded-lg border">
          <div className="flex items-center gap-2">
            {isOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
            <MessageCircle className="h-4 w-4 text-blue-500" />
            <span className="font-semibold text-sm">Communications</span>
            <Badge variant="outline" className="text-xs text-muted-foreground">Coming Soon</Badge>
          </div>
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="px-4 pt-2 pb-4">
          <p className="text-sm text-muted-foreground">
            In progress — calls, texts, and emails will appear here soon and can be attached to this ticket.
          </p>
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
